import type { Tone } from "../shared/types";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** "2025-08-21" → "Aug 21, 2025" (dates are calendar dates — no timezone shifts). */
export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number);
  return `${MONTHS[m - 1]} ${d}, ${y}`;
}

/** "2025-08-21" → "Aug 2025" */
export function fmtMonth(iso: string | null | undefined): string {
  if (!iso) return "—";
  const [y, m] = iso.slice(0, 7).split("-").map(Number);
  return `${MONTHS[m - 1]} ${y}`;
}

/** "2025-08-21" → "08/21/2025" (chain rail style). */
export function fmtShort(iso: string): string {
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${m}/${d}/${y}`;
}

export function fmtRange(from: string, to: string | null): string {
  if (!to || to === from) return fmtDate(from);
  const [fy, fm, fd] = from.split("-").map(Number);
  const [ty, tm, td] = to.split("-").map(Number);
  if (fy === ty && fm === tm) return `${MONTHS[fm - 1]} ${fd}–${td}, ${fy}`;
  return `${fmtDate(from)} – ${fmtDate(to)}`;
}

export const lbToKg = (lb: number) => Math.round(lb * 0.453592 * 10) / 10;

export const shortHash = (h: string) => `${h.slice(0, 8)}…${h.slice(-6)}`;

export const TONE: Record<Tone, { bg: string; fg: string }> = {
  high: { bg: "var(--hl)", fg: "var(--hi)" },
  warn: { bg: "var(--wl)", fg: "var(--w)" },
  ok: { bg: "var(--ol)", fg: "var(--ok)" },
  info: { bg: "var(--ll)", fg: "var(--lo)" },
  teal: { bg: "var(--tl)", fg: "var(--teal)" },
  purple: { bg: "var(--pl)", fg: "var(--pu)" },
};

export const speciesEmoji = (species: string) => (/fel|cat/i.test(species) ? "🐈" : /can|dog/i.test(species) ? "🐕" : "🐾");

/** Older records carry the status inside the name ("Hypothyroidism — suspected"); the status column is authoritative. */
export const conditionName = (name: string) => name.replace(/\s+—\s+(active|suspected|managed)$/i, "");

export const STATUS_PILL: Record<string, { label: string; tone: Tone }> = {
  active: { label: "Active", tone: "warn" },
  suspected: { label: "Suspected", tone: "high" },
  managed: { label: "Managed", tone: "ok" },
  resolved: { label: "Resolved", tone: "ok" },
};
